const DEFAULT_WS_PATH = '/api/events/ws'

function defaultDevelopmentUrl() {
    const hostname = (typeof window !== 'undefined' && window.location?.hostname) || 'localhost'
    return `ws://${hostname}:5023${DEFAULT_WS_PATH}`
}

function currentLocationUrl(path = DEFAULT_WS_PATH) {
    if (typeof window === 'undefined') return ''
    const resolvedPath = path.startsWith('/') ? path : `/${path}`
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${window.location.host}${resolvedPath}`
}

function uniqueUrls(values) {
    const seen = new Set()
    return values
        .map(value => (typeof value === 'string' ? value.trim() : ''))
        .filter(value => {
            if (!value || seen.has(value)) return false
            seen.add(value)
            return true
        })
}

export function resolveWebSocketCandidates(environment = import.meta.env || {}) {
    const isProd = Boolean(environment.PROD)
    const envUrl = typeof environment.VITE_WS_URL === 'string'
        ? environment.VITE_WS_URL.trim()
        : ''
    if (isProd && !envUrl) throw new Error('VITE_WS_URL must be defined in production')
    if (isProd && !envUrl.startsWith('/')) {
        throw new Error('VITE_WS_URL must be a same-origin path in production')
    }

    const urls = isProd
        ? uniqueUrls([currentLocationUrl(envUrl)])
        : uniqueUrls([envUrl, currentLocationUrl(), defaultDevelopmentUrl()])
    if (!urls.length) {
        throw new Error(isProd
            ? 'Unable to determine WebSocket URL for production'
            : 'Unable to determine WebSocket URL candidates')
    }
    return { urls, isProd }
}

export function nextReconnectDelay(currentBackoff, random = Math.random) {
    const baseDelay = Math.min(currentBackoff, 15000)
    const nextBackoff = Math.min(baseDelay * 2, 15000)
    const jitterFactor = 0.8 + random() * 0.4
    return { delay: Math.round(baseDelay * jitterFactor), nextBackoff }
}
